export const PERSIST_VERSION = 2;
